import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }

import TextContent from '@/components/TextContent.vue'
import { ref } from 'vue'
import CaretDown from '@/assets/icons/caret-down.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'RowWithInfo',
  props: {
    title: null
  },
  setup(__props: any) {



const expanded = ref(false)
const toggle = () => expanded.value = !expanded.value

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          class: _normalizeClass(_ctx.$style.expand),
          onClick: toggle
        }, [
          _createElementVNode("span", null, _toDisplayString(__props.title), 1),
          _createElementVNode("img", {
            src: _unref(CaretDown),
            alt: "Arrow down",
            class: _normalizeClass(_ctx.$style.caret)
          }, null, 10, _hoisted_1)
        ], 2)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
          _createElementVNode("td", {
            colspan: "3",
            class: _normalizeClass(_ctx.$style.infoTd)
          }, [
            _createVNode(TextContent, {
              class: _normalizeClass(_ctx.$style.info)
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "info")
              ]),
              _: 3
            }, 8, ["class"])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})